import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

// força modo claro
document.body.classList.remove('app-dark');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
